import {
  ProjectWorkItemsPage,
  loadProjectWorkItems,
  workItemsSearchSchema,
} from "@/components/work-items/project-list";
import { createFileRoute } from "@tanstack/react-router";

/**
 * `/projects/:slug/work-items` — the project's work-item list,
 * rendered inside the project layout.
 *
 * The page, its loader and its search schema live in
 * `@/components/work-items/project-list` so the GitLab-native
 * `/{group}/{project}/-/work_items` route can render the same list
 * without importing from this route file — that would defeat the
 * router plugin's code-splitting.
 */
export const Route = createFileRoute("/_app/projects/$slug/work-items/")({
  validateSearch: workItemsSearchSchema,
  loaderDeps: ({ search }) => ({
    q: search.q,
    status: search.status,
    priority: search.priority,
    type: search.type,
    assignee: search.assignee,
    author: search.author,
    watcher: search.watcher,
    attachments: search.attachments,
    scope: search.scope,
    release: search.release,
    environment: search.environment,
    dueAfter: search.dueAfter,
    dueBefore: search.dueBefore,
    sort: search.sort,
    dir: search.dir,
    page: search.page,
    pageSize: search.pageSize,
  }),
  loader: ({ params, deps }) => loadProjectWorkItems(params.slug, deps),
  component: ProjectWorkItemsPage,
});
